import request from '@/utils/request'

export default {
  async selectInteraction (params) {
    let res = await request.get('/interactions/select', { params })
    return res.data
  },
  async addInteractionRecord (params) {
    let res = await request.post('/interactions/addRecord', params)
    return res.data
  },
  async delelteInteractionRecord (params) {
    let res = await request.get('/interactionRecords/delete', { params })
    return res.data
  }
}
